import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../store/store";

export interface AppThunkInput<T, U> {
  data: T,
  onSuccess?: (responseData: U) => void,
  onFailure?: (error: any) => void,
};

export interface AppThunkApi {
  getState: () => RootState,
  dispatch: (action: any) => void,
}

export const createAppAsyncThunk = <T, U> (
  actionName: string,
  requestCreator: (data: T, thunkApi: AppThunkApi) => Promise<U>,
) => {
  return createAsyncThunk(
      actionName,
      async (input: AppThunkInput<T, U>, thunkApi) => {
          const { dispatch, rejectWithValue, getState } = thunkApi
          try {
              const response: U = await requestCreator(
                  input.data, 
                  { 
                      getState: getState as () => RootState,
                      dispatch,
                  }
              );
              input.onSuccess?.(response);
              return response;
          } catch (error) {
              // if (shouldLogout(error as ErrorResponse)) {
              //     logger.error(`breaking error while making a request -> logout`);
              //     dispatch(logout());
              // }
              input.onFailure?.(error)
              return rejectWithValue(error);
          }
      }
  )
}